// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"70acb872","205":"4c22c5ca","551":"0d677b8d","617":"242adcd1","629":"9fd9de61"}[chunkId] + ".chunk.js";
};